import { ArrayInput, FormDataConsumer, required, SelectInput, SimpleFormIterator } from "react-admin";
import { Box, CircularProgress, Grid } from "@mui/material";
import InfoBlock from "./InfoBlock";
import { settings } from "app";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { FromWeekToWeekChoices } from "utils/choices";
import { validateFromToWeek } from "../utils/utils";

const EditProfessors = ({ isLoading, currentSchedule, disciplineId, specialityId }) => {
  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={200} />
        </Box>
      ) : (
        <>
          <InfoBlock
            currentSchedule={currentSchedule}
            disciplineId={disciplineId}
            specialityId={specialityId}
          />
          <ArrayInput
            source="professors"
            label="Преподаватели"
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              sx={settings.style.iteratorWithoutGap}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                >
                  <ProfessorInput
                    source="employeeId"
                    label="Преподавател"
                    fullWidth
                    validate={[required()]}
                    filters={{ disciplineId }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
              >
                <FormDataConsumer>
                  {({ scopedFormData }) => (
                    <>
                      <Grid
                        item
                        xs={12}
                        md={4}
                      >
                        <SelectInput
                          source="fromWeek"
                          label="От седмица"
                          choices={FromWeekToWeekChoices}
                          validate={[required(), () => validateFromToWeek(scopedFormData)]}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={4}
                      >
                        <SelectInput
                          source="toWeek"
                          label="До седмица"
                          choices={FromWeekToWeekChoices}
                          validate={[required(), () => validateFromToWeek(scopedFormData)]}
                        />
                      </Grid>
                    </>
                  )}
                </FormDataConsumer>
              </Grid>
            </SimpleFormIterator>
          </ArrayInput>
        </>
      )}
    </>
  );
};

export default EditProfessors;
